import React, {
  FC,
  useState,
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  ReactNode,
} from 'react'

const SearchContext = createContext<{
  search: number[]
  setSearch: Dispatch<SetStateAction<any[]>>
  selected: number
  setSelected: Dispatch<SetStateAction<number>>
}>(null)

export const useSearchState = () => useContext(SearchContext)

const SearchState: FC<{ children: ReactNode }> = ({ children }) => {
  const [search, setSearch] = useState([])
  const [selected, setSelected] = useState()
  return (
    <SearchContext.Provider
      value={{ search, setSearch, selected, setSelected }}
    >
      {children}
    </SearchContext.Provider>
  )
}

export default SearchState
